export default "__VITE_ASSET__Dan7N3QB__"